"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const IdHeader_1 = __importDefault(require("../../../components/IdHeader"));
const DownloadApp = () => {
    return (react_1.default.createElement("div", { className: "password-confirmed" },
        react_1.default.createElement(IdHeader_1.default, { handlerFunction: function () {
                throw new Error("Function not implemented.");
            } }),
        react_1.default.createElement("div", { className: "password-confirmed__container" },
            react_1.default.createElement("div", { className: "password-confirmed__content" },
                react_1.default.createElement("h1", { className: "password-confirmed__title" }, "Download Fuvar"),
                react_1.default.createElement("p", { className: "password-confirmed__text" }, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam ullamcorper ut urna ac dictum. Quisque accumsan dolor at dui semper, et bibendum justo vehicula. Aliquam massa libero, commodo ut enim eu, pulvinar accumsan metus. Cras quam neque, imperdiet et leo et, consequat dapibus est."),
                react_1.default.createElement("div", { className: "password-confirmed__download-buttons" },
                    react_1.default.createElement("div", { className: "android" },
                        react_1.default.createElement("img", { src: "images/android_download.png", width: 150 })),
                    react_1.default.createElement("div", { className: "ios" },
                        react_1.default.createElement("img", { src: "images/apple_download.png", width: 150 })))))));
};
exports.default = DownloadApp;
if (document.getElementById("pages-download")) {
    (0, client_1.createRoot)(document.getElementById("pages-download")).render(react_1.default.createElement(DownloadApp, null));
}
